module.exports = __webpack_public_path__ + "jtails-build/img/person_background.5969a58d.svg";